// Central WhatsApp helper. All CTAs on the site route through here.
export const WHATSAPP_NUMBER = "918121448600";
export const WHATSAPP_DISPLAY = "+91 81214 48600";

export const openWhatsApp = (message) => {
  const text =
    message ||
    "Hello, I would like to enquire about premium green cardamom from The Cardamom Trading Co.";
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    text
  )}`;
  window.open(url, "_blank", "noopener,noreferrer");
};

export const buildEnquiryMessage = ({
  name,
  phone,
  email,
  quantity,
  message,
}) => {
  const lines = [
    "Hello, I would like to enquire about premium green cardamom.",
    "",
    `Name: ${name || "-"}`,
    `Phone: ${phone || "-"}`,
  ];
  if (email && email.trim()) lines.push(`Email: ${email}`);
  if (quantity && quantity.trim()) lines.push(`Quantity Required: ${quantity}`);
  if (message && message.trim()) {
    lines.push("");
    lines.push(`Message: ${message}`);
  }
  lines.push("");
  lines.push("— sent from thecardamomtrading.co");
  return lines.join("\n");
};
